import CardProfileGame from "./CardProfileGame";
export default CardProfileGame;